import { render, staticRenderFns } from "./list-order.vue?vue&type=template&id=6fed83ab&scoped=true"
import script from "./list-order.vue?vue&type=script&lang=js"
export * from "./list-order.vue?vue&type=script&lang=js"
import style0 from "./list-order.vue?vue&type=style&index=0&id=6fed83ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed83ab",
  null
  
)

export default component.exports